import { createFileRoute } from '@tanstack/react-router';
import { buildBreadcrumbs } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { CopyButton } from '@interxfi/design-system/components/copy-button/copy-button';
import { AssetLogoBreadcrumb } from '../../../../../../../../../../../features/asset/logo/asset-logo-breadcrumb';
import { getPortfolioCashBalanceDetailPath } from '../../../../../../../../../../../features/portfolio/cash-balance/cash-balance-routing';
import { SweepBalanceBreadcrumb } from '../../../../../../../../../../../features/portfolio/sweep-balance/sweep-balance-breadcrumb';
import { SweepBalanceDetailLayout } from '../../../../../../../../../../../features/portfolio/sweep-balance/sweep-balance-detail-layout';
import { getPortfolioSweepBalanceDetailPath } from '../../../../../../../../../../../features/portfolio/sweep-balance/sweep-balance-routing';
import { getPageHead } from '../../../../../../../../../../../util/routing/meta';

export const Route = createFileRoute('/_app/_clearing-core/registration/account/$accountId/_account/_detail/cash/_cash/sweep/$assetId')({
  loader: ({ params }) =>
    buildBreadcrumbs([
      {
        id: `account-cash-${params.accountId}`,
        label: 'Cash & Equivalents',
        to: getPortfolioCashBalanceDetailPath(params.accountId),
      },
      {
        id: `account-cash-sweep-${params.accountId}-${params.assetId}`,
        prefix: <AssetLogoBreadcrumb assetId={params.assetId} />,
        label: <SweepBalanceBreadcrumb assetId={params.assetId} />,
        to: getPortfolioSweepBalanceDetailPath(params.accountId, params.assetId),
        suffix: <CopyButton content={params.assetId} label="Copy Asset ID" tooltip={{ copy: params.assetId, copied: 'Copied Asset ID' }} />,
      },
    ]),
  head: () => getPageHead('Cash & Equivalents — Sweep Balance'),
  component: AccountCashSweepDetail,
});

function AccountCashSweepDetail() {
  const { accountId, assetId } = Route.useParams();

  return <SweepBalanceDetailLayout accountId={accountId} assetId={assetId} />;
}
